import request from '@/request'

export async function search (query) {
  const response = await request({
    url: `/search?q=${query}`,
    method: 'get'
  })

  return response.data
}